module.exports = __webpack_public_path__ + "img/icon0.4328cb61.png";